import { SlotDto } from '@/types';
import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { Observable, of } from 'rxjs';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

@Component({
  selector: 'sm-ppm-slots-form',
  imports: [InputTextModule, InputNumberModule, ButtonModule, CommonModule, FormsModule, TranslateModule, ConfirmDialogModule],
  templateUrl: './slots-form.component.html',
  styleUrl: './slots-form.component.scss',
  providers: [ConfirmationService],
})
export class PpmSlotsFormComponent implements OnInit {
  @Input() value: Observable<SlotDto[]> = of([]);
  @Input() onChange?: (event: SlotDto[]) => void;
  @Input() errors: Observable<{ description: string; budget: string }[]> = of([]);
  @Input() disabled = of(false);

  private confirmationService = inject(ConfirmationService);
  private translate = inject(TranslateService);

  slots: SlotDto[] = []; // Local array
  uid = new Date().getTime();

  ngOnInit() {
    this.value.subscribe(slots => {
      this.slots = (slots || []).map(slot => ({ ...slot }));
    });
  }

  addLot() {
    this.slots.push({ description: '', budget: undefined });
    this.onChange?.([...this.slots]);
  }

  updateText(index: number, newValue: string) {
    this.slots[index].description = newValue;
    this.onChange?.([...this.slots]);
  }

  updateNumber(index: number, newValue: number) {
    this.slots[index].budget = newValue;
    this.onChange?.([...this.slots]);
  }

  removeLot(index: number) {
    this.confirmationService.confirm({
      message: this.translate.instant('confirm_delete.slot'),
      header: this.translate.instant('confirmation'),
      acceptLabel: this.translate.instant('common.dialog.confirm'),
      rejectLabel: this.translate.instant('common.dialog.cancel'),
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.slots.splice(index, 1);
        this.onChange?.([...this.slots]);
      },
    });
  }

  clearAllLots() {
    this.confirmationService.confirm({
      message: this.translate.instant('confirm_delete.slots'),
      header: this.translate.instant('confirmation'),
      acceptLabel: this.translate.instant('common.dialog.confirm'),
      rejectLabel: this.translate.instant('common.dialog.cancel'),
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.slots = [];
        this.onChange?.([]);
      },
    });
  }

  trackByFn(index: number) {
    return index;
  }
}
